






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class HIVEAlert extends Vue {
  @Prop(String) public alertType
  @Prop(String) public alertText

  public get displayAlert() {
    return this.alertType === '' || this.alertText === '' ? false : true
  }

  private clear() {
    this.$emit('clear')
  }
}
